/**
 * 客户管理员禁入守卫
 *
 * REQ-20260615-0009：客户（子租户）管理员只能"选用"平台预设角色，不能自建角色 / 改菜单。
 * 因此把「角色管理 / 菜单管理 / 权限资源」入口对客户管理员关闭，重定向回工作台。
 * 这是 UI 收口；后端 foundation role_logic 对子租户的角色 CRUD 已有 403 兜底。
 */

import React from 'react';
import { Navigate } from 'react-router-dom';
import { isCustomerAdmin } from '@/utils/auth';

export interface CustomerAdminBlockedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

const CustomerAdminBlockedRoute: React.FC<CustomerAdminBlockedRouteProps> = ({
  children,
  redirectTo = '/tenant/dashboard',
}) => {
  if (isCustomerAdmin()) {
    return <Navigate to={redirectTo} replace />;
  }
  return <>{children}</>;
};

export default CustomerAdminBlockedRoute;
